import Skeleton from "react-loading-skeleton";

import Box from "ds/components/Box";
import Card from "ds/components/Card";

const SKELETON_CARD_COUNT = 4;

const LaunchPadTrackMissionCompletionCardsSkeleton = () => (
  <Box grid gridTemplate={`repeat(${SKELETON_CARD_COUNT}, 1fr)`} gap="large">
    {Array.from({ length: SKELETON_CARD_COUNT }).map((_, index) => (
      <Card key={index} fullWidth zeroMinWidth>
        <Box direction="column" gap="medium" zeroMinWidth>
          <Box direction="row" align="center" gap="small" zeroMinWidth>
            <Skeleton count={1} height={18} width={120} borderRadius={4} />
            <Skeleton count={1} height={16} width={16} borderRadius={4} />
          </Box>
          <Skeleton count={1} height={32} width={80} borderRadius={4} />
          <Skeleton count={1} height={16} width={70} borderRadius={4} />
        </Box>
      </Card>
    ))}
  </Box>
);
export default LaunchPadTrackMissionCompletionCardsSkeleton;
